import React from "react";
import CryptoJS from "crypto-js";
// @material-ui/icons
import Face from "@material-ui/icons/Face";
import RecordVoiceOver from "@material-ui/icons/RecordVoiceOver";
import Email from "@material-ui/icons/Email";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import PictureUpload from "components/CustomUpload/PictureUpload.jsx";
import API from "@aws-amplify/api";
import { TextField } from "@material-ui/core";
import Button from "components/CustomButtons/Button.jsx";
import { Auth } from "aws-amplify";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import "assets/scss/styles.css";
let apiName = process.env.REACT_APP_AMPLIFY_API;

class EditProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('given_name'),'secretpass').toString(CryptoJS.enc.Utf8)),
      lastname: JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('family_name'),'secretpass').toString(CryptoJS.enc.Utf8)),
      email: JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('email'),'secretpass').toString(CryptoJS.enc.Utf8)),
      firstnameState: "",
      lastnameState: "",
      emailState: "",
      edited: false,
      tr: false,
      message: "",
      color: "success",
      data: []
    };
    this.handleSave = this.handleSave.bind(this);
  }
  componentDidMount() {
    let path = "/users";
    let myInit1 = {
      headers: {
        userId: JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('userId'),'secretpass').toString(CryptoJS.enc.Utf8))
      }
    };
    API.get(apiName, path, myInit1).then(response => {
      this.setState({
        data: response
      });
    });
  }
  async handleSave() {
    let user = await Auth.currentAuthenticatedUser();
    let result = await Auth.updateUserAttributes(user, {
      given_name: this.state.firstname,
      family_name: this.state.lastname
    });
    let path = "/users";
    let myInit1 = {
      headers: {
        userId: JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('userId'),'secretpass').toString(CryptoJS.enc.Utf8))
      },
      body: {
        // userId : JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('userId'),'secretpass').toString(CryptoJS.enc.Utf8)),
        // clientId: this.state.data[0].clientId,
        // qlikUserDirectory: this.state.data[0].qlikUserDirectory,
        // qlikUserId: this.state.data[0].qlikUserId,
        // createdAt: this.state.data[0].createdAt,
        lastName: this.state.lastname,
        firstName: this.state.firstname
        // email: JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('email'),'secretpass').toString(CryptoJS.enc.Utf8)),
      }
    };
    localStorage.setItem("given_name", this.state.firstname);
    localStorage.setItem("family_name", this.state.lastname);
    localStorage.setItem("email", this.state.email);
    API.put(apiName, path, myInit1)
      .then(response => {
        this.setState({
          message: "Data Updated Successfully.",
          color: "success"
        });
        this.showNotification("tr");
      })
      .catch(error => {
      });
    setTimeout(
      function() {
        this.setState({
          edited: true
        });
        // this.props.history.push("/userProfile");
        // window.location.reload();
      }.bind(this),
      6000
    );
  }
  showNotification = place => {
    if (!this.state[place]) {
      var x = [];
      x[place] = true;
      this.setState(x);
      setTimeout(
        function() {
          x[place] = false;
          this.setState(x);
        }.bind(this),
        6000
      );
    }
  };
  sendState() {
    return this.state;
  }
  // function that returns true if value is email, false otherwise
  verifyEmail(value) {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }
  // function that verifies if a string has a given length or not
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }
  change(event, stateName, type, stateNameEqualTo) {
    switch (type) {
      case "email":
        if (this.verifyEmail(event.target.value)) {
          this.setState({ [stateName + "State"]: "success" });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "length":
        if (this.verifyLength(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "success" });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      default:
        break;
    }
    this.setState({ [stateName]: event.target.value });
  }
  isValidated() {
    if (
      this.state.firstnameState === "success" &&
      this.state.lastnameState === "success" &&
      this.state.emailState === "success"
    ) {
      return true;
    } else {
      if (this.state.firstnameState !== "success") {
        this.setState({ firstnameState: "error" });
      }
      if (this.state.lastnameState !== "success") {
        this.setState({ lastnameState: "error" });
      }
      if (this.state.emailState !== "success") {
        this.setState({ emailState: "error" });
      }
    }
    return false;
  }
  render() {
    const { classes } = this.props;
    return (
      <GridContainer justify="center">
        <Snackbar
          place="tr"
          color={this.state.color}
          message={this.state.message}
          open={this.state.tr}
          closeNotification={() => this.setState({ tr: false })}
          close
        />
        {/* <GridItem xs={12} sm={4} /> */}
        <GridItem xs={12} sm={4}>
          <div className={classes.details}>
            <TextField
              className="inputField"
              success={this.state.firstnameState === "success"}
              error={this.state.firstnameState === "error"}
              label={
                <span>
                  First Name <small>(required)</small>
                </span>
              }
              id="firstname"
              value={this.state.firstname}
              formControlProps={{
                fullWidth: true
              }}
              InputProps={{
                onChange: event => this.change(event, "firstname", "length", 3),
                endAdornment: (
                  <InputAdornment position="end" className="inputAdornment">
                    <Face className="inputAdornmentIcon" />
                  </InputAdornment>
                )
              }}
            />
            <TextField
              className="inputField"
              success={this.state.lastnameState === "success"}
              error={this.state.lastnameState === "error"}
              label={
                <span>
                  Last Name <small>(required)</small>
                </span>
              }
              id="lastname"
              value={this.state.lastname}
              formControlProps={{
                fullWidth: true
              }}
              InputProps={{
                onChange: event => this.change(event, "lastname", "length", 3),
                endAdornment: (
                  <InputAdornment position="end" className="inputAdornment">
                    <RecordVoiceOver className="inputAdornmentIcon" />
                  </InputAdornment>
                )
              }}
            />
            {/* <TextField
              className="inputField"
              success={this.state.emailState === "success"}
              error={this.state.emailState === "error"}
              label={
                <span>
                  Email <small>(required)</small>
                </span>
              }
              id="email"
              value={this.state.email}
              formControlProps={{
                fullWidth: true
              }}
              InputProps={{
                onChange: event => this.change(event, "email", "email"),
                endAdornment: (
                  <InputAdornment position="end" className="inputAdornment">
                    <Email className="inputAdornmentIcon" />
                  </InputAdornment>
                )
              }}
            /> */}
            {/* <Button>Update Password</Button> */}
          </div>
        </GridItem>
        <GridItem xs={12} className="buttonMarginTop40">
          <Button color="secondary" onClick={() => this.handleSave()}>
            Save
          </Button>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(notificationsStyle)(EditProfile);



// WEBPACK FOOTER //
// ./src/views/User/EditProfile.jsx